export const selectWholeInfo = state => state.info

export const selectIsWarehousesAndMovementsDataLoaded = state => {
  return (
    !!state.Info.data.movementTypes &&
    !!state.Info.data.allWarehouses &&
    !!state.Info.data.usersWithMovements &&
    state.Info.data.ready
  )
}

export const selectMovementTypes = state => state.Info.data.movementTypes
export const selectWarehouses = state => state.Info.data.allWarehouses
export const selectUsersWithMovements = state =>
  state.Info.data.usersWithMovements
